import { icons } from 'src/assets/iconDef/icon.def';

export const appointmentMenuDef = [
    {
        name: 'menu.appointment',
        icon: 'fa fa-calendar',
        children: [

            {
                name: 'Appointment',
                resource: 'appointment_format',
                icon: 'fa fa-plus-square',
                url: 'appointment_format',
                auto_crud: true,
                breadcrumb: 'Appointment',
                check_permission: false
            },
            {
                name: 'menu.appointment',
                icon: 'fa fa-calendar',
                resource: 'appointment',
                url: 'appointment',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Appointment',
            },
            {
                name: 'menu.appointment',
                icon: 'fa fa-calendar',
                resource: 'diagnostic',
                url: 'diagnostic',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Appointment',
                check_permission: false
            },
            {
                name: 'menu.appointment',
                icon: 'fa fa-calendar',
                resource: 'phc_package',
                url: 'phc_package',
                auto_crud: true,
                breadcrumb: 'Appointment',
                check_permission: false
            },
            {
                name: 'menu.appointment',
                icon: 'fa fa-calendar',
                resource: 'corporate_phc_package',
                url: 'corporate_phc_package',
                auto_crud: true,
                breadcrumb: 'Appointment',
                check_permission: false
            },
            {
                name: 'menu.appointment',
                icon: 'fa fa-calendar',
                resource: 'appointment_doctor_format',
                url: 'appointment_doctor_format',
                auto_crud: true,
                breadcrumb: 'Appointment'
            },
            {
                name: 'menu.appointment',
                icon: 'fa fa-calendar',
                resource: 'appointment_patient',
                url: 'appointment_patient',
                auto_crud: true,
                breadcrumb: 'Appointment',
            },
            {
                "name": "menu.pathology",
                "resource": "corporate_phc_package_format",
                "icon": "fa fa-file-text-o",
                "url": "corporate_phc_package_format",
                "auto_crud": true,
                "breadcrumb": "corporate_phc_package_format",
                "check_permission": false
            },
            {
                "name": "menu.archived_appointment",
                "resource": "archived_appointment",
                "icon": "fa fa-plus-square",
                "url": "archived_appointment",
                "auto_crud": true,
                "showMenu": true,
                "check_permission": false,
                "breadcrumb": "",

            },
            {
                name: 'menu.eligibility_form',
                resource: 'eligibility_form',
                icon: 'fa fa-plus-square',
                url: 'eligibility_form',
                check_permission: false,
                auto_crud: true,
                showMenu: true
            },
            {
                name: 'menu.update_profile',
                resource: 'medical_image_upload',
                icon: 'fa fa-plus-square',
                url: 'medical_image_upload',
                check_permission: false,
                auto_crud: true,
                showMenu: true
            },
            {
                resource: 'bulk_cancellation_services',
                name: 'menu.bulk_cancellation_services',
                icon: 'fa fa-plus-square',
                url: 'bulk_cancellation_services',
                auto_crud: true,
                showMenu: true,
                check_permission: true,
                breadcrumb: 'Bulk Cancellation Services'
            },
            {
                resource: 'appointment_outsource_op_package',
                icon: 'fa fa-plus-square',
                url: 'appointment_outsource_op_package',
                auto_crud: true,
                showMenu: true,
                check_permission: false,
                breadcrumb: 'Outsource OP Package'
            }
        ]
    },

]
